import React, {useEffect, useState,useCallback} from "react";
import {observer, inject} from "mobx-react";
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import axios from 'axios';


const InstagramImages = props => {
    const [images, setImages] = useState([]);
    const isMountedRef = useIsMountedRef();
    
    const getMedia = useCallback(async() => {
        try {
            const res = await axios.get("/Umbraco/Api/InstagramApi/GetMedia?userid="+props.userid+"&numberOfImages="+props.numberofimages,{}, null);
            if (isMountedRef.current) {
                setImages(res.data);
            }
        } catch (err) {
            return null;
        }
    }, [useIsMountedRef])

    useEffect(() => {
        getMedia();
    }, [getMedia]);

    return <div className={"container"}>{images && images.length > 0 && <div className={"row instagram-container"}>{images && images.map(image => {
        let cols = 12 / Math.round(Math.sqrt(images.length));
        if (cols < 2) {
            cols = 2;
        }
        
        const imageUrl = image.thumbnail_url != null && image.thumbnail_url !== "null" ? image.thumbnail_url : image.media_url;
        
        return <div key={image.thumbnail_url || image.media_url} className={"col-lg-" + cols+" col-6 instagram-image"}><a href={image.permalink || "#"} target={"_blank"}><div style={{background: "url("+imageUrl+")"}}><img src="/dist/img/instagram_ph.jpg" /></div></a></div>
    })}{props.addlogo && <div className={"instagram-logo"}><img src="/dist/img/instagram_ph.jpg" /></div>}</div>}</div>;
}


@inject("store")
@observer
export default class Instagram extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (<div className="instagram-images"><InstagramImages userid={this.props.control.value.data.userid}
                                                                   numberofimages={this.props.control.value.data.numberofimages} addlogo={this.props.control.value.data.addlogo}/>
        </div>);
    }
}